'use client'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getWishlist } from '@/services'
import { useWishlistStore } from '@/store/wishlist'
import { useEffect } from 'react'

export const useWishlistSync = (currentPage: number, pageSize: number) => {
  const queryClient = useQueryClient()
  const { wishlistItems, getWishlist: getWishlistFromStore } = useWishlistStore()

  // TanStack Query
  const {
    data: wishlistData,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['getWishlist', currentPage, pageSize],
    queryFn: () =>
      getWishlist({
        page: currentPage,
        pageSize: pageSize,
      }).then((res) => res?.items_v2),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
  })

  // Đồng bộ data từ TanStack Query vào Zustand Store
  useEffect(() => {
    if (wishlistData && !isLoading) {
      // Cập nhật Zustand store với data từ TanStack Query
      getWishlistFromStore({ page: currentPage, pageSize })
    }
  }, [wishlistData, isLoading, currentPage, pageSize, getWishlistFromStore])

  // Function để invalidate cả TanStack Query và Zustand Store
  const invalidateWishlist = () => {
    queryClient.invalidateQueries({ queryKey: ['getWishlist'] })
    getWishlistFromStore({ page: currentPage, pageSize })
  }

  return {
    // Data từ TanStack Query (primary source)
    wishlistData,
    isLoading,
    error,
    refetch,

    // Data từ Zustand Store (secondary source)
    wishlistItems,

    // Actions
    invalidateWishlist,
  }
}
